<template>
  <component
    :is="tag"
    :class="classesRoot"
  >
    <div v-if="green" :class="$style.greenRhombus">
      <svg xmlns="http://www.w3.org/2000/svg" width="412" height="92" viewBox="0 0 412 92"
           fill="none"
      >
        <path d="M412 46.2026L219.021 0L0 46.2026L192.311 92L412 46.2026Z" fill="#A4E064"/>
      </svg>
    </div>
    <div
      v-if="subtitle"
      :class="$style.subtitle"
    >
      {{ subtitle }}
    </div>
    <div :class="[rightsubtitle && $style.rightsubtitleWrap]">
    <div :class="$style.title">
      {{ title }}
    </div>
    <div
      v-if="rightsubtitle"
      :class="$style.rightsubtitle"
    >
      {{ rightsubtitle }}
    </div>
    </div>
  </component>
</template>

<script>
const tagValidator = (_) => ['div', 'h1', 'h2', 'h3'].includes(_);

export default {
  name: 'UiHeading',
  props: {
    tag: {
      type: String,
      default: 'div',
      validate: tagValidator,
    },

    title: {
      type: String,
      default: null,
    },
    subtitle: {
      type: String,
      default: null,
    },
    rightsubtitle: {
      type: String,
      default: null,
    },
    indent: {
      type: Boolean,
      default: false,
    },
    green: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    classesRoot() {
      const { $style } = this;
      return {
        [$style.root]: true,
        [$style.isIndent]: this.indent,
        [$style.greenWrap]: this.green,
      };
    },
  },
};
</script>

<style lang="scss" module>
.root {
  margin-top: 0;
  margin-bottom: 0;

  &.isIndent {
    @include media('xs') {
      margin-bottom: 24px;
    }

    @include mediaMin('sm') {
      margin-bottom: 32px;
    }
  }
}

.greenWrap {
  padding: 24px 0 0;
  max-width: 970px;
  position: relative;
  display: flex;
  flex-direction: column;
  @include media('xs') {
    padding-top: 68px;
  }
}
.greenRhombus {
  width: 412px;
  height: 92px;
  top: 27px;
  left: -107px;
  z-index: -1;
  position: absolute;
  @include media('xs') {
    top: 70px;
  }
}

.title {
  @include media('xs') {
    @include typography(40px, 40px);
    font-weight: 500;
  }

  @include mediaMin('sm') {
    @include typography(50px, 50px);
    font-weight: 500;
  }
}

.subtitle {
  margin-top: 5px;
  @include typography(20px, 15px);
  font-weight: 400;
}
.rightsubtitle {
  opacity: 0.5;
  margin-top: 5px;
  margin-left: 15px;
  max-width: 250px;
  @include typography(14px, 15px);
  font-weight: 400;
  @include media('xs') {
    margin-left: 0;
  }
}
.rightsubtitleWrap {
  display: flex;
  align-items: center;
  @include media('xs') {
    flex-direction: column;
    align-items: start;
  }
}
</style>
